import React from 'react'
import {
  help as HelpIcon,
  blog as BlogIcon,
  tips as TipsIcon,
} from 'assets/icons/groove/v2'
import ButtonWithMenu from '../ButtonWithMenu'
import { styles } from './styles'

const activeColor = 'color.info.50'

const Menu = ({ onClose }) => {
  return (
    <ButtonWithMenu.Menu css={styles.menu}>
      <ButtonWithMenu.Menu.Item
        icon={<HelpIcon className="md-icon" />}
        title="The Groove KB"
        copy="Helpful documentation and tutorials on how to use Groove."
        as="a"
        href="https://help.groovehq.com/help"
        target="_blank"
        rel="noopener noreferrer"
        className="grui"
        onClick={onClose}
        activeColor={activeColor}
      />
      <ButtonWithMenu.Menu.Item
        icon={<TipsIcon className="md-icon" />}
        title="Product roadmap"
        copy="Explore new and upcoming features on our product roadmap."
        as="a"
        href="https://www.groovehq.com/our-roadmap"
        target="_blank"
        rel="noopener noreferrer"
        className="grui"
        onClick={onClose}
        activeColor={activeColor}
      />
      <ButtonWithMenu.Menu.Item
        icon={<BlogIcon className="blog" />}
        title="Customer service blog"
        copy="Our own blog dedicated to all things customer support."
        as="a"
        href="https://www.groovehq.com/blog/customer-support"
        target="_blank"
        rel="noopener noreferrer"
        className="grui"
        onClick={onClose}
        activeColor={activeColor}
      />
    </ButtonWithMenu.Menu>
  )
}

export default Menu
